import ts from "../src/assets/ts.webp"
import pnpm from "../src/assets/pnpm.webp"

import resume from "../src/assets/GokulResume26.pdf";

// Mock data for portfolio
export const personalInfo = {
  name: "Gokul Krishnan Koyattassery",
  title: "Full-Stack Developer | MERN Stack | React & React Native",
  subtitle: "MERN & ReactNative Developer",
  bio: "Passionate full-stack developer with expertise in building scalable web and mobile applications. I specialize in the MERN stack and have a proven track record of delivering high-quality solutions that solve real-world problems.",
  avatar: "https://codingseagull.netlify.app/static/media/man.2bd9115285b9a4a2656a.png",
  email: "codingseagull@gmail.com",
  location: "Kingdom of Saudi Arabia",
  resumeUrl: resume, 
  socials: {
    github: "https://github.com/GokulkrishnanRvm",
    linkedin: "https://linkedin.com/in/gkk007",
    email: "mailto:codingseagull@gmail.com"
  }
};

export const skills = [
  { name: "React.js", category: "Frontend", level: 90 },
  { name: "Next.Js", category: "Frontend", level: 75 },
  { name: "React Native", category: "Mobile", level: 85 },
  { name: "Node.js", category: "Backend", level: 88 },
  { name: "Express.js", category: "Backend", level: 87 },
  { name: "MongoDB", category: "Database", level: 85 },
  { name: "JavaScript", category: "Language", level: 92 },
  { name: "TypeScript", category: "Language", level: 80 },
  { name: "HTML/CSS", category: "Frontend", level: 95 },
  { name: "Tailwind CSS", category: "Frontend", level: 90 },
  { name: "Git", category: "Tools", level: 88 },
  { name: "REST APIs", category: "Backend", level: 90 },
  { name: "iOS Development", category: "Mobile", level: 75 },
  { name: "Android Development", category: "Mobile", level: 75 },
  { name: "SQL", category: "Database", level: 75 },
  { name: "PLSQL", category: "Database", level: 75 },
];

export const experience = [
  {
    id: 1,
    title: " Full-Stack Developer",
    company: "Saudi Development Company",
    location: "Al Qassim , Saudi Arabia",
    startDate: "Jan 2023",
    endDate: "Present",
    description: "Leading development of enterprise-level web & mobile applications using MERN stack and Reactnative. Architecting scalable solutions as a solo software engineer.",
    achievements: [
      "Improved application performance by 40% through optimization",
      "Designed and Developed multiple projects",
      "Implemented CI/CD pipeline reducing deployment time by 60%"
    ]
  },
  {
    id: 2,
    title: "Full-Stack Developer",
    company: "Freelance Web developer",
    location: "Kochi, India",
    startDate: "Jun 2021",
    endDate: "jan 2023",
    description: "Developed and maintained multiple client projects using React, Node.js, and MongoDB. Created responsive web applications and mobile apps.",
    achievements: [
      "Successfully delivered 15+ projects on time including e-commerce and portfolio websites",
      "Reduced API response time by 35%",
      "Developed reusable component library used across projects"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "CMMS",
    description: "Computerised Maintenance Management System to track the maintenance process with histories maintenance activities. It also generates cost reports in various conditions. It Also uses user roles (authorisation & authentication)",
    image: "https://codingseagull.netlify.app/static/media/Cmms.be3a131e796cfffb5789.jpeg",
    technologies: ["React", "Node.js", "MongoDB", "Express"],
    liveUrl: "https://cmms-cementix.netlify.app/",
    githubUrl: "https://github.com/GokulkrishnanRvm",
    featured: true
  },
  {
    id: 2,
    title: "Github Users",
    description: "Github users is the React webapp providing github users search by using github api and also plotted the information by charts with fusioncharts API.",
    image: "https://codingseagull.netlify.app/static/media/githubusers.ead2fad3c058327a86b4.png",
    technologies: ["React", "GitHub API", "FusionCharts"],
    liveUrl: "https://github-users-search-react-app2023.netlify.app/",
    githubUrl: "https://github.com/GokulkrishnanRvm",
    featured: true
  },
  {
    id: 3,
    title: "Campo",
    description: "Yelpcamp is the Nodejs web app providing camping facilities to travellers and it is a CRUD application using technologies are mongodb, ejs, express and bootstrap.",
    image: "https://codingseagull.netlify.app/static/media/campo.96bda71c225492c6034a.jpeg",
    technologies: ["Node.js", "MongoDB", "Express", "EJS"],
    liveUrl: "https://campo-yelpcamp-nodejs-app.onrender.com/",
    githubUrl: "https://github.com/GokulkrishnanRvm",
    featured: true
  },
  {
    id: 4,
    title: "Comfy Sloth",
    description: "Comfy sloth is a E-commerce web application. It has multiple functionalities like sort, filter product search and product order and added dummy payment by using stripe.",
    image: "https://codingseagull.netlify.app/static/media/comfy.b0fb9d1c23229f7f138f.png",
    technologies: ["React", "Stripe", "Context API"],
    liveUrl: "https://react-ecommerce-app-2023.netlify.app/",
    githubUrl: "https://github.com/GokulkrishnanRvm",
    featured: false
  },
  {
    id: 5,
    title: "Quiz Master",
    description: "Quiz master is the react web app created by using opentb API. You can customise the entire quiz like number of questions, difficulty, category and finally you will get the final score.",
    image: "https://codingseagull.netlify.app/static/media/quiz.7d8658bee6104f7143b2.png",
    technologies: ["React", "OpenTDB API"],
    liveUrl: "https://react-quiz-master-opentdb.netlify.app/",
    githubUrl: "https://github.com/GokulkrishnanRvm",
    featured: false
  },
  {
    id: 6,
    title: "Task Management Pro",
    description: "A comprehensive task management application with real-time collaboration, drag-and-drop interface, and team productivity analytics. Built with modern web technologies.",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&h=600&fit=crop",
    technologies: ["React", "Node.js", "Socket.io", "MongoDB"],
    liveUrl: "#",
    githubUrl: "https://github.com/GokulkrishnanRvm",
    featured: false
  }
];


export const blogs = [
  {
  id: 5,
  title: "pnpm vs Yarn vs npm: Choosing the Right Package Manager in 2026",
  excerpt: "Package managers are the backbone of modern JavaScript development. With pnpm's rise in popularity, developers face a crucial choice. This comprehensive comparison helps you understand the strengths and trade-offs of each tool.",
  image: pnpm,
  date: "2026-01-08",
  readTime: "9 min read",
  tags: ["pnpm", "Yarn", "npm", "Package Management", "DevOps"],
  slug: "pnpm-vs-yarn-vs-npm"
},
  {
    id: 0,
    title: "Learning TypeScript: A Game Changer for JavaScript Developers",
    excerpt: "JavaScript is powerful, but TypeScript adds safety. It helps catch errors early, makes code easier to maintain, and saves time as projects grow. Once you use TypeScript, going back to plain JavaScript feels risky.",
    image: ts,
    date: "2026-01-01",
    readTime: "7 min read",
    tags: ["TypeScript", "JavaScript", "Js vs Ts"],
    slug: "learning-typescript-game-changer"
  },
  {
    id: 1,
    title: "Building Scalable React Applications: Best Practices",
    excerpt: "Learn the essential patterns and practices for building maintainable and scalable React applications that can grow with your team.",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=500&fit=crop",
    date: "2024-01-15",
    readTime: "8 min read",
    tags: ["React", "JavaScript", "Best Practices"],
    slug: "building-scalable-react-applications"
  },
  {
    id: 2,
    title: "Mastering React Native: From Web to Mobile",
    excerpt: "Transition from React web development to React Native mobile development with this comprehensive guide covering key differences and gotchas.",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=500&fit=crop",
    date: "2024-01-08",
    readTime: "10 min read",
    tags: ["React Native", "Mobile Development", "iOS", "Android"],
    slug: "mastering-react-native"
  },
  {
    id: 3,
    title: "Node.js Performance Optimization Tips",
    excerpt: "Discover practical techniques to optimize your Node.js applications for better performance, reduced memory usage, and improved scalability.",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=500&fit=crop",
    date: "2023-12-22",
    readTime: "6 min read",
    tags: ["Node.js", "Performance", "Backend"],
    slug: "nodejs-performance-optimization"
  },
  {
    id: 4,
    title: "MongoDB Schema Design Patterns",
    excerpt: "Explore common MongoDB schema design patterns and learn when to use embedded documents vs references for optimal database performance.",
    image: "https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=800&h=500&fit=crop",
    date: "2023-12-10",
    readTime: "7 min read",
    tags: ["MongoDB", "Database", "Architecture"],
    slug: "mongodb-schema-design-patterns"
  },

];

// Detailed blog content
export const blogContent = {
  "pnpm-vs-yarn-vs-npm": {
  introduction: "The JavaScript ecosystem has evolved significantly since npm's inception. Today, developers have three major choices for package management: npm (the default), Yarn (the challenger), and pnpm (the efficient newcomer). Each has distinct advantages, and choosing the right one can significantly impact your development workflow, CI/CD pipelines, and disk space usage.",
  sections: [
    {
      heading: "The Evolution of JavaScript Package Managers",
      content: [
        "npm was the first and remains the default package manager for Node.js. Released in 2010, it established the foundation for JavaScript's package ecosystem. However, as projects grew larger and monorepos became common, npm's limitations became apparent.",
        "Yarn entered the scene in 2016, addressing npm's speed and reliability issues with features like offline caching and deterministic installs via yarn.lock. It quickly gained adoption among major companies and open-source projects.",
        "pnpm, first released in 2017 but gaining significant traction since 2020, took a different approach. Instead of duplicating packages across projects, pnpm uses a content-addressable storage system that creates hard links to a single store. This dramatically reduces disk space usage and installation time."
      ]
    },
    {
      heading: "Speed Comparison: Where Performance Matters",
      content: [
        "Speed is often the first consideration when choosing a package manager. In real-world benchmarks, pnpm consistently outperforms both npm and Yarn, especially in monorepo environments and when installing packages with many dependencies."
      ],
      list: [
        "pnpm: Fastest installation times due to its efficient linking mechanism and parallel operations. Cold installs are up to 2x faster than npm.",
        "Yarn: Fast with good caching mechanisms. Yarn 2+ (Berry) introduced zero-installs for even faster CI/CD pipelines.",
        "npm: Slowest of the three, though npm 7+ has improved significantly. Still the most predictable and stable option."
      ],
      content: [
        "The speed advantage of pnpm becomes more pronounced as your project grows. In a monorepo with dozens of packages sharing dependencies, pnpm's approach of storing each package version once and linking it everywhere else provides massive performance gains."
      ]
    },
    {
      heading: "Disk Space Efficiency: The pnpm Advantage",
      content: [
        "Disk space might not seem critical on modern development machines, but it matters significantly in CI/CD environments, Docker images, and when working with multiple projects simultaneously."
      ],
      list: [
        "pnpm: Uses a global store with hard links, saving up to 70% disk space compared to npm. If you have 10 projects using React 18, React is stored once, not 10 times.",
        "Yarn: Uses a global cache but still copies files to node_modules, resulting in moderate disk usage.",
        "npm: Creates separate node_modules for each project with no sharing between projects, leading to highest disk usage."
      ],
      content: [
        "For developers working on multiple projects or teams running extensive CI/CD pipelines, pnpm's disk efficiency translates to real cost savings and faster build times."
      ]
    },
    {
      heading: "Workspace and Monorepo Support",
      content: [
        "Modern development often involves monorepos—multiple packages in a single repository. All three package managers support workspaces, but with varying levels of maturity and features."
      ],
      code: `# pnpm workspace configuration (pnpm-workspace.yaml)
packages:
  - 'packages/*'
  - 'apps/*'

# Yarn workspace configuration (package.json)
{
  "workspaces": [
    "packages/*",
    "apps/*"
  ]
}

# npm workspace configuration (package.json)
{
  "workspaces": [
    "packages/*",
    "apps/*"
  ]
}`,
      list: [
        "pnpm: Built-in workspace support with the strictest isolation. Prevents phantom dependencies—accidental access to packages not listed in package.json.",
        "Yarn: Excellent workspace support, especially in Yarn 2+. The hoisting mechanism is flexible but can allow phantom dependencies.",
        "npm: Added workspace support in npm 7. Functional but less feature-rich than pnpm or Yarn."
      ]
    },
    {
      heading: "Security Considerations",
      content: [
        "Security in package management goes beyond just vulnerability scanning. It includes how packages access dependencies and whether they can access unlisted packages."
      ],
      list: [
        "pnpm: Most secure due to strict isolation. Packages can only access declared dependencies, preventing supply chain attacks that rely on phantom dependencies.",
        "Yarn: Secure with built-in checksum verification. Yarn 2+ improved security further with stricter resolution algorithms.",
        "npm: Standard security with npm audit. The flat node_modules structure can expose packages to dependencies they shouldn't access."
      ],
      content: [
        "pnpm's strict mode catches dependency issues early that might slip through in npm or Yarn projects. This strictness can be a learning curve but ultimately leads to more maintainable codebases."
      ]
    },
    {
      heading: "Developer Experience and Ecosystem Support",
      content: [
        "Beyond raw performance and features, developer experience matters. This includes documentation, community support, IDE integration, and compatibility with build tools and platforms."
      ],
      list: [
        "npm: Largest community, most documentation, universal compatibility. Every tool supports npm.",
        "Yarn: Strong community support, excellent documentation, widely supported by major frameworks and tools.",
        "pnpm: Growing rapidly but smaller community. Some tools may have npm/Yarn-specific features not yet available for pnpm."
      ],
      content: [
        "In practice, modern tools like Vite, Next.js, Turborepo, and Nx support all three package managers. However, some older tools or enterprise solutions may assume npm, requiring workarounds with pnpm or Yarn."
      ]
    },
    {
      heading: "Migration Considerations",
      content: [
        "Switching package managers isn't trivial, but it's usually straightforward. Here's what to consider when migrating:"
      ],
      list: [
        "From npm to pnpm: Delete node_modules and package-lock.json, install pnpm, run pnpm install. Most projects work immediately.",
        "From npm to Yarn: Delete node_modules and package-lock.json, install Yarn, run yarn install. Usually seamless.",
        "Between any managers: Check CI/CD scripts, Docker files, and documentation. Update lockfile in git.",
        "Monorepo migrations: May require workspace configuration changes and dependency hoisting adjustments."
      ]
    },
    {
      heading: "Real-World Use Cases: Which Should You Choose?",
      content: [
        "The right choice depends on your specific needs, team size, and project requirements. Here's practical guidance:"
      ],
      list: [
        "Choose pnpm if: You work with monorepos, value disk space efficiency, want strict dependency management, or need maximum speed. Ideal for teams building multiple projects or microservices.",
        "Choose Yarn if: You need battle-tested stability, work in a team already using Yarn, want Plug'n'Play (PnP) zero-install features, or need specific Yarn ecosystem tools.",
        "Choose npm if: You want zero configuration, maximum compatibility, simplicity over performance, or are just starting with Node.js. npm is always a safe, predictable choice."
      ],
      content: [
        "Many organizations are migrating to pnpm for new projects while maintaining existing projects on npm or Yarn. There's no need to force migration—each package manager is production-ready and actively maintained."
      ]
    },
    {
      heading: "Performance Benchmarks: The Numbers",
      content: [
        "Based on recent benchmarks with a typical React application with 50+ dependencies:"
      ],
      code: `Cold Install (no cache):
- pnpm: 14s
- Yarn: 24s  
- npm: 31s

With Cache:
- pnpm: 7s
- Yarn: 9s
- npm: 17s

Disk Space (10 projects):
- pnpm: 2.1 GB
- Yarn: 4.8 GB
- npm: 6.7 GB`,
      content: [
        "These benchmarks vary based on your dependency tree, network speed, and hardware, but the relative differences remain consistent. pnpm's advantages become more pronounced as project complexity increases."
      ]
    },
    {
      heading: "The Future of Package Management",
      content: [
        "The JavaScript package management landscape continues to evolve. npm has incorporated many features inspired by Yarn and pnpm. Yarn 2+ (Berry) introduced revolutionary concepts like Plug'n'Play. pnpm's approach has proven so effective that even npm is exploring similar optimizations.",
        "The competition between these tools has driven innovation that benefits all JavaScript developers. We now have faster installs, better security, and more efficient disk usage than ever before. The future likely involves continued convergence of best practices while each tool maintains its unique strengths."
      ]
    }
  ],
  conclusion: "There's no definitive 'best' package manager—the choice depends on your priorities. pnpm offers the best performance and disk efficiency, making it ideal for monorepos and teams managing many projects. Yarn provides excellent stability and advanced features like Plug'n'Play. npm offers universal compatibility and simplicity. For new projects in 2026, pnpm is increasingly the default choice among performance-conscious developers, but npm remains perfectly viable for most use cases. Whichever you choose, you're working with mature, production-ready tools that will serve you well."
},
  "learning-typescript-game-changer": {
    introduction: "TypeScript has revolutionized the way we write JavaScript. What started as a Microsoft project has become the de facto standard for building large-scale applications. In this article, we'll explore why TypeScript is a game changer and how it can transform your development workflow.",
    sections: [
      {
        heading: "Why TypeScript Matters",
        content: [
          "JavaScript is incredibly flexible, which is both its greatest strength and its biggest weakness. This flexibility allows developers to write code quickly, but it also means that errors often don't surface until runtime. TypeScript addresses this fundamental issue by adding static type checking to JavaScript.",
          "With TypeScript, you catch errors at compile time rather than runtime. This shift might seem small, but it has profound implications for code quality, developer productivity, and maintainability. Instead of discovering bugs in production, you find them while writing code."
        ]
      },
      {
        heading: "Key Benefits of TypeScript",
        content: [
          "The advantages of TypeScript extend far beyond simple type checking. Let's explore the major benefits that make it essential for modern development:"
        ],
        list: [
          "Type Safety: Catch errors before they reach production with compile-time type checking",
          "Better IDE Support: Enhanced autocomplete, refactoring tools, and inline documentation",
          "Improved Code Documentation: Types serve as living documentation that never goes out of date",
          "Easier Refactoring: Change code with confidence knowing TypeScript will catch breaking changes",
          "Team Collaboration: Clear interfaces make it easier for teams to work on shared codebases",
          "Gradual Adoption: Start with JavaScript and add types incrementally as needed"
        ]
      },
      {
        heading: "TypeScript vs JavaScript: A Practical Comparison",
        content: [
          "Let's look at a real-world example that demonstrates the power of TypeScript. Consider a simple function that processes user data:"
        ],
        code: `// JavaScript - No type safety
function processUser(user) {
  return {
    fullName: user.firstName + ' ' + user.lastName,
    age: new Date().getFullYear() - user.birthYear
  };
}

// Easy to make mistakes
processUser({ name: 'John' }); // Runtime error!

// TypeScript - Type safe
interface User {
  firstName: string;
  lastName: string;
  birthYear: number;
}

function processUser(user: User) {
  return {
    fullName: user.firstName + ' ' + user.lastName,
    age: new Date().getFullYear() - user.birthYear
  };
}

// TypeScript catches the error immediately
processUser({ name: 'John' }); // Compile error!`,
        content: [
          "In the JavaScript version, the error only appears at runtime. In the TypeScript version, your IDE flags the problem immediately. This instant feedback loop is transformative for development speed and code quality."
        ]
      },
      {
        heading: "Getting Started with TypeScript",
        content: [
          "Starting with TypeScript is easier than you might think. You don't need to convert your entire codebase overnight. TypeScript supports gradual adoption, meaning you can rename files from .js to .ts one at a time and add types progressively.",
          "For a new project, setting up TypeScript is straightforward. Install TypeScript via npm, create a tsconfig.json file, and you're ready to go. Modern build tools like Vite, Create React App, and Next.js come with TypeScript support out of the box."
        ]
      },
      {
        heading: "Common Pitfalls and How to Avoid Them",
        content: [
          "While TypeScript is powerful, beginners often struggle with certain concepts. Here are the most common mistakes and how to avoid them:"
        ],
        list: [
          "Using 'any' type everywhere defeats the purpose of TypeScript. Be explicit with your types.",
          "Over-engineering types can make code harder to read. Start simple and add complexity as needed.",
          "Ignoring TypeScript errors with @ts-ignore should be a last resort, not a habit.",
          "Not leveraging utility types like Partial, Pick, and Omit can lead to code duplication.",
          "Forgetting that TypeScript only provides compile-time safety, not runtime validation."
        ]
      },
      {
        heading: "TypeScript in the Real World",
        content: [
          "Major companies and open-source projects have adopted TypeScript for good reason. Airbnb reported finding 38% of bugs could have been prevented with TypeScript. Google uses TypeScript extensively, and the Angular framework is built entirely with it.",
          "The React ecosystem has embraced TypeScript wholeheartedly. Popular libraries like Redux Toolkit, React Query, and styled-components provide excellent TypeScript support. The community has created DefinitelyTyped, which provides type definitions for thousands of JavaScript libraries."
        ]
      }
    ],
    conclusion: "TypeScript isn't just a trend—it's a fundamental improvement to JavaScript that makes development safer, faster, and more enjoyable. The initial learning curve is worth it. Once you experience the confidence of knowing your code is type-safe, the productivity gains from better IDE support, and the ease of maintaining large codebases, going back to plain JavaScript feels unnecessarily risky. Start small, be patient with yourself, and embrace the TypeScript journey."
  },
  "building-scalable-react-applications": {
    introduction: "Building a React application is easy. Building a React application that scales gracefully as your team and features grow is much harder. This guide covers the essential patterns and practices learned from building production applications that serve millions of users.",
    sections: [
      {
        heading: "Component Architecture",
        content: [
          "The foundation of a scalable React application is a well-thought-out component architecture. This means organizing your components in a way that promotes reusability, maintainability, and testability."
        ],
        list: [
          "Keep components small and focused on a single responsibility",
          "Use composition over inheritance to build complex UIs",
          "Separate presentational components from container components",
          "Create a shared component library for consistency across your app",
          "Implement proper prop drilling prevention with Context or state management"
        ]
      },
      {
        heading: "State Management Best Practices",
        content: [
          "As your application grows, state management becomes critical. Choose the right tool for the job: useState for local state, Context for shared UI state, and a dedicated library like Redux or Zustand for complex global state.",
          "Avoid premature optimization. Start with local state and lift it up only when necessary. Many applications are over-engineered with complex state management when simpler solutions would suffice."
        ]
      },
      {
        heading: "Performance Optimization",
        content: [
          "React is fast, but it's easy to introduce performance bottlenecks. Here are key strategies to keep your app running smoothly:"
        ],
        list: [
          "Use React.memo() for expensive component renders",
          "Implement code splitting with React.lazy() and Suspense",
          "Optimize re-renders with useMemo and useCallback hooks",
          "Use virtualization for long lists with libraries like react-window",
          "Monitor performance with React DevTools Profiler"
        ]
      },
      {
        heading: "Folder Structure and Organization",
        content: [
          "A scalable folder structure helps teams work efficiently. Group by feature rather than by file type. Each feature should contain its components, hooks, utilities, and tests in one place."
        ],
        code: `src/
├── features/
│   ├── auth/
│   │   ├── components/
│   │   ├── hooks/
│   │   ├── api/
│   │   └── index.ts
│   ├── dashboard/
│   └── profile/
├── shared/
│   ├── components/
│   ├── hooks/
│   └── utils/
└── App.tsx`
      },
      {
        heading: "Testing Strategy",
        content: [
          "Testing is non-negotiable for scalable applications. Implement a testing pyramid: lots of unit tests, some integration tests, and a few end-to-end tests. Use React Testing Library for component tests and Playwright or Cypress for E2E tests."
        ]
      }
    ],
    conclusion: "Building scalable React applications requires discipline, good patterns, and a focus on maintainability from day one. These practices might feel like overhead initially, but they pay dividends as your application grows. Remember: code is read more often than it's written, so optimize for clarity and maintainability."
  },
  "mastering-react-native": {
    introduction: "React Native promises write once, run anywhere. The reality is more nuanced. While you can share significant code between iOS and Android, mastering React Native requires understanding platform-specific nuances and mobile development patterns. This guide will help you make the transition from React web to React Native mobile development.",
    sections: [
      {
        heading: "Core Differences from React Web",
        content: [
          "React Native isn't just React with different components. The fundamental difference is that React Native doesn't use HTML or CSS—it uses native components. Instead of div, you use View. Instead of span, you use Text. These aren't just renamed elements; they're actual native UI components."
        ],
        list: [
          "No DOM: React Native uses native components, not HTML elements",
          "Styling: Uses a JavaScript object-based styling system similar to CSS",
          "Navigation: Requires separate navigation libraries like React Navigation",
          "Platform APIs: Access to device features like camera, location, and sensors",
          "Performance: Direct compilation to native code for better performance"
        ]
      },
      {
        heading: "Styling in React Native",
        content: [
          "Styling in React Native uses a subset of CSS implemented in JavaScript. Flexbox is the primary layout system, but it works slightly differently than on the web. By default, flex containers are column-oriented in React Native."
        ],
        code: `import { StyleSheet, View, Text } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f0f0f0',
  },
  text: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
});

export const MyComponent = () => (
  <View style={styles.container}>
    <Text style={styles.text}>Hello React Native!</Text>
  </View>
);`
      },
      {
        heading: "Navigation Patterns",
        content: [
          "Navigation in mobile apps is fundamentally different from web navigation. React Native requires a navigation library, with React Navigation being the most popular choice. It provides stack navigation, tab navigation, and drawer navigation patterns that feel native to each platform."
        ]
      },
      {
        heading: "Platform-Specific Code",
        content: [
          "Sometimes you need different code for iOS and Android. React Native provides several ways to handle platform-specific code, from simple Platform.select() calls to separate .ios.js and .android.js files."
        ]
      },
      {
        heading: "Common Gotchas",
        content: [
          "React Native development comes with unique challenges. Here are the most common issues developers face:"
        ],
        list: [
          "ScrollView must have a bounded height or it won't scroll properly",
          "Images require explicit width and height dimensions",
          "Text must be wrapped in a Text component, not placed directly in View",
          "Debugging requires different tools (React Native Debugger, Flipper)",
          "Hot reloading sometimes requires full app restart"
        ]
      }
    ],
    conclusion: "React Native is a powerful platform for building mobile applications, but it requires a mindset shift from web development. Embrace platform-specific patterns, learn to think in native components, and don't fight the framework. With practice, you'll be building smooth, native-feeling apps that share code across platforms while respecting each platform's conventions."
  },
  "nodejs-performance-optimization": {
    introduction: "Node.js performance optimization is crucial for building scalable applications. Poor performance doesn't just affect user experience—it increases infrastructure costs and can bring your application to its knees under load. This guide covers practical techniques you can implement today to make your Node.js applications faster and more efficient.",
    sections: [
      {
        heading: "Understanding the Event Loop",
        content: [
          "The Node.js event loop is the heart of its non-blocking I/O model. Understanding how it works is essential for writing performant code. The event loop handles asynchronous operations through a queue system, but blocking the event loop is the fastest way to kill performance."
        ],
        list: [
          "Avoid synchronous operations in production code",
          "Break up CPU-intensive tasks into smaller chunks",
          "Use worker threads for heavy computational tasks",
          "Monitor event loop lag with tools like clinic.js",
          "Never block the event loop with long-running synchronous operations"
        ]
      },
      {
        heading: "Memory Management",
        content: [
          "Memory leaks are silent killers in Node.js applications. They start small and gradually degrade performance until your application crashes. Common culprits include event listeners not being removed, global variables accumulating data, and cached data never being cleared."
        ],
        code: `// Bad: Memory leak
const events = [];
app.on('request', (req) => {
  events.push(req); // Never cleared!
});

// Good: Bounded cache
const LRU = require('lru-cache');
const cache = new LRU({ max: 500 });

app.on('request', (req) => {
  cache.set(req.id, req);
});`
      },
      {
        heading: "Database Query Optimization",
        content: [
          "Database queries are often the bottleneck in Node.js applications. Optimize your queries, use proper indexing, and implement connection pooling. Consider using query result caching for frequently accessed data."
        ],
        list: [
          "Use connection pooling to reuse database connections",
          "Implement proper database indexes for frequently queried fields",
          "Use query result caching with Redis for read-heavy workloads",
          "Batch database operations when possible",
          "Use database query profiling tools to identify slow queries"
        ]
      },
      {
        heading: "Caching Strategies",
        content: [
          "Caching is one of the most effective performance optimizations. Implement caching at multiple levels: application-level with Redis, HTTP caching with proper headers, and content delivery networks (CDNs) for static assets."
        ]
      },
      {
        heading: "Monitoring and Profiling",
        content: [
          "You can't optimize what you don't measure. Implement comprehensive monitoring and profiling from day one. Tools like Clinic.js, New Relic, and DataDog provide insights into where your application spends its time and where bottlenecks exist."
        ]
      }
    ],
    conclusion: "Performance optimization is an ongoing process, not a one-time task. Start with proper monitoring to identify bottlenecks, then optimize the slowest parts first. Remember the 80/20 rule: 20% of your code is responsible for 80% of performance issues. Focus on those critical paths, and your application will fly."
  },
  "mongodb-schema-design-patterns": {
    introduction: "MongoDB schema design is fundamentally different from relational database design. The flexibility of document databases is both liberating and challenging. This guide explores common schema design patterns that help you build performant and maintainable MongoDB applications.",
    sections: [
      {
        heading: "Embedded vs Referenced Data",
        content: [
          "The most important decision in MongoDB schema design is whether to embed related data or reference it. This choice affects query performance, data consistency, and application complexity. The rule of thumb: embed data that's accessed together, reference data that's accessed independently."
        ],
        code: `// Embedded pattern - good for 1-to-few relationships
{
  _id: ObjectId("..."),
  name: "John Doe",
  addresses: [
    { street: "123 Main St", city: "Boston" },
    { street: "456 Oak Ave", city: "Portland" }
  ]
}

// Referenced pattern - good for 1-to-many relationships
// User document
{
  _id: ObjectId("..."),
  name: "John Doe"
}

// Order documents
{
  _id: ObjectId("..."),
  userId: ObjectId("..."),
  total: 99.99
}`
      },
      {
        heading: "The Subset Pattern",
        content: [
          "When you have a one-to-many relationship where the 'many' side can grow very large, the subset pattern is your friend. Store the most frequently accessed items embedded in the parent document, and keep the full list in a separate collection."
        ],
        list: [
          "Reduces document size by storing only essential data",
          "Improves query performance for common operations",
          "Maintains access to complete data when needed",
          "Ideal for product reviews, comments, or activity logs",
          "Balances between embedding and referencing approaches"
        ]
      },
      {
        heading: "The Extended Reference Pattern",
        content: [
          "Sometimes you need to reference another document but frequently access a few fields from it. The extended reference pattern duplicates these frequently accessed fields to avoid joins while maintaining a reference to the complete document."
        ]
      },
      {
        heading: "Schema Design Anti-Patterns",
        content: [
          "Certain patterns consistently lead to performance problems in MongoDB. Avoid these common mistakes:"
        ],
        list: [
          "Massive arrays: Arrays with thousands of elements cause performance issues",
          "Unbounded documents: Documents that grow indefinitely will eventually exceed the 16MB limit",
          "Bloat: Storing unnecessary data that's never accessed",
          "Application-side joins: Performing joins in application code instead of using $lookup",
          "One collection per user: Creates management nightmares and doesn't scale"
        ]
      },
      {
        heading: "Indexing Strategies",
        content: [
          "Proper indexing is critical for MongoDB performance. Create indexes for fields used in queries, sorts, and joins. But remember: indexes have a cost. Each index slows down writes and takes up storage space. Be strategic about which indexes you create."
        ]
      }
    ],
    conclusion: "MongoDB schema design requires understanding your application's query patterns and data access patterns. There's no one-size-fits-all solution. Start simple, measure performance, and refactor as needed. The flexibility of MongoDB allows you to evolve your schema as your application grows, which is one of its greatest strengths."
  },
  
};

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Product Manager",
    company: "Tech Innovations Inc.",
    content: "Gokul is an exceptional developer who consistently delivers high-quality work. His expertise in the MERN stack and attention to detail have been invaluable to our projects.",
    avatar: "https://i.pravatar.cc/150?img=1"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "CTO",
    company: "Digital Solutions Ltd.",
    content: "Working with Gokul has been a pleasure. He not only writes clean, maintainable code but also brings innovative solutions to complex problems. Highly recommended!",
    avatar: "https://i.pravatar.cc/150?img=2"
  }
];